;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');

	Controller.offSeason = function() {

	};

	_.extend(Controller.offSeason.prototype, {

		offSeason: function() {
			this.view = new Layout.OffSeasonBaseLayout();
			
			APP.main.show(this.view);
			this.view.main.show(new View.OffSeasonBase({
				model: new Model.PreRegistration()
			}));

		}

	});

	APP.on('start', function() {
		new Router.offSeason({controller: new Controller.offSeason()});
	});

}(window, APP, Backbone, Marionette, $, _));